// Note: https://www.npmjs.com/package/react-pro-sidebar

import React, { useState } from 'react';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';

import ic_collapse_arrow from "assets/images/ic_collapse_arrow.svg";
import ic_expand_arrow from "assets/images/ic_expand_arrow.svg";

import { func_validation, func_url, isArrayNotEmpty } from 'functions';

import "assets/scss/components/sidebars/sidebar.scss";



export function Sidebar(props) {
    const { sidebarClassName,
        isWidthChangerIconVisible,
        isHeaderVisible, 
        headerImageClassName, isHeaderImageVisible, headerImage, headerImageAlt, widthChangeIconClassName,
        expandIcon, collapseIcon,
        isHeaderDetailsVisible, headerDetailsClassName, isHeaderDetailsVisible_topBorder, isHeaderDetailsVisible_bottomBorder, headerDetailsDisplay,
        menuArray,
        menuItemIconClassName, menuItemLabelClassName,
        isMenuItemExpanderIconVisible
    } = props;

    // States
    const [isCollapsed, setIsCollapsed] = useState(false);
    
    function handleOnClick_headerImage() {
        const { headerImageUrlRedirection } = props;

        if (func_validation.isStringTrimNotEmpty(headerImageUrlRedirection))
            func_url.historyPushToURL(props, headerImageUrlRedirection);
    }

    // Width Change
    let widthChangerIcon = {};
    if (isCollapsed) widthChangerIcon = expandIcon? expandIcon:ic_expand_arrow;
    else widthChangerIcon = collapseIcon? collapseIcon:ic_collapse_arrow;

    // Menu
    let sidebarMenus = (
        <SidebarMenu {...props}
            menuItemIconClassName={menuItemIconClassName}
            menuItemLabelClassName={menuItemLabelClassName}
            menuArray={menuArray}

            isCollapsed={isCollapsed}
        />
    );

    return (
        <ProSidebar
            className={"component-sidebar " +
                (sidebarClassName? sidebarClassName + " ":"")}
            collapsed={isCollapsed}
        >
            {/*  Header */}
            {isHeaderVisible? (
                <div className={"component-sidebar-header"}>
                    {/* Header Image */}
                    <div className={"component-sidebar-headerImageWrapper d-flex align-items-center " +
                            (headerImageClassName? headerImageClassName + " ":"")}>
                        {isHeaderImageVisible && (!isCollapsed)? (
                            <div className="component-sidebar-headerImageWrapper">
                                <img
                                    className={"component-sidebar-headerImage"}
                                    src={headerImage}
                                    alt={headerImageAlt}

                                    onClick={handleOnClick_headerImage}
                                />
                            </div>
                        ):""}

                        {/* Change Sidebar Width Action */}
                        {isWidthChangerIconVisible? (
                            <div className={"component-sidebar-widthChangerActionWrapper d-flex flex-fill align-items-start " +
                                    (isCollapsed? "justify-content-center ":"justify-content-end ")}>
                                <img 
                                    className={"component-sidebar-widthChangerAction " +
                                        (widthChangeIconClassName? widthChangeIconClassName + " ":"")} 
                                    src={widthChangerIcon}
                                    alt={"Arrow Icon"}

                                    onClick={() => { setIsCollapsed(!isCollapsed); }}
                                /> 
                            </div>
                        ):""}   
                    </div>

                    {/* Header Details */}
                    {isHeaderDetailsVisible && (!isCollapsed)? (
                        <div className={"component-sidebar-headerDetailsWrapper d-flex align-items-center " +
                                        (headerDetailsClassName? headerDetailsClassName + " ":"") +
                                        (isHeaderDetailsVisible_topBorder? "component-sidebar-headerDetails_topBorder ":"") +
                                        (isHeaderDetailsVisible_bottomBorder? "component-sidebar-headerDetails_bottomBorder ":"")}>
                            {headerDetailsDisplay(isCollapsed)}
                        </div>
                    ):""}

                </div>
            ):""}
            
            {/* Body */}
           <div className={"component-sidebar-menu " +
                (!isMenuItemExpanderIconVisible? "component-sidebar-menu_hideExpanderIcon ":"")}>
                <Menu>{sidebarMenus}</Menu>
            </div>
        </ProSidebar>
    )
}

function SidebarMenu(props) {
    const {
        isCollapsed, isSubmenu, isSuperSubMenu,
        menuArray, 
        menuItemIconClassName, menuItemLabelClassName,
        currentPath, isIconHidden, isItemSelectedIndicatorHidden,
    } = props;

    const { pathname } = useLocation();
    const [isSubMenuVisible, setIsSubMenuVisible] = useState();

    let menu = "";
    if (func_validation.isArrayNotEmpty(menuArray)) {
        menu = menuArray.map((itemDetail, idx) => {
            let itemIconDisplay = func_validation.getObjectPropertyValue(itemDetail, "itemIconDisplay");
            let isIconHidden = func_validation.getObjectPropertyValue(itemDetail, "isIconHidden");
            let isItemSelectedIndicatorHidden = func_validation.getObjectPropertyValue(itemDetail, "isItemSelectedIndicatorHidden");
            let itemLabel = func_validation.getObjectPropertyValue(itemDetail, "itemLabel");
            let subItemLabel = func_validation.getObjectPropertyValue(itemDetail, "subItemLabel");
            let path = func_validation.getObjectPropertyValue(itemDetail, "path");
            let submenuArray = func_validation.getObjectPropertyValue(itemDetail, "subMenu");
            let isDisabled = func_validation.getObjectPropertyValue(itemDetail, "isDisabled");
            let iconClassName = func_validation.getObjectPropertyValue(itemDetail, "iconClassName");
            let isNotificationVisible = itemDetail?.isNotificationVisible;
            let notificationValue = itemDetail?.notificationValue;
            let isSubmenuPresent = func_validation.isArrayNotEmpty(submenuArray);

            let submenu = "";
            let isSubmenuItemSelected = false;
            if (isSubmenuPresent) {
                submenu = (
                    <SidebarMenu {...props}
                        menuItemIconClassName={menuItemIconClassName}
                        menuItemLabelClassName={menuItemLabelClassName}
                        menuArray={submenuArray}

                        isIconHidden={isIconHidden}
                        isItemSelectedIndicatorHidden={isItemSelectedIndicatorHidden}
                        isSubmenu
                        isSuperSubMenu={isSubmenu}
                    />
                );

                // Check if any sub menu is selected
                submenuArray.map((itemDetail) => { 
                    let path = func_validation.getObjectPropertyValue(itemDetail, "path");
                    let isItemSelected = func_validation.isStringEqual_caseInsensitive(path, currentPath);
                    if (isItemSelected) isSubmenuItemSelected = isItemSelected;

                    // Check if any super sub menu is selected
                    let submenu = func_validation.getObjectPropertyValue(itemDetail, "subMenu");
                    if (isArrayNotEmpty(submenu)) {
                        submenu.map((itemDetail) => { 
                            let path = func_validation.getObjectPropertyValue(itemDetail, "path");
                            let isItemSelected = func_validation.isStringEqual_caseInsensitive(path, currentPath);
                            if (isItemSelected) isSubmenuItemSelected = isItemSelected;
                        });
                    }
                });
            }

            let isItemSelected = func_validation.isStringEqual_caseInsensitive(path, currentPath);

            return (
                <React.Fragment key={idx}> 
                    {(!isSubmenu || !isSuperSubMenu) && isSubmenuPresent && !isDisabled? (
                        <SubMenu
                            // Props specifically for library
                            firstchild={props.firstchild}
                            popperarrow={props.popperarrow}
                            open={isSubmenuItemSelected || isItemSelected || isSubMenuVisible}

                            onClick={() => {
                                setIsSubMenuVisible(false);
                            }}

                            className={"component-sidebar-menuItem " + 
                                (isDisabled? "component-sidebar-menuItem_noCursor ":"")}
                            defaultOpen={isSubmenuItemSelected}

                            icon={(
                                <Link className="component-sidebar-menuItemWrapper d-flex align-items-center " onClick={() => path === pathname? window.location.reload():""} to={(!isDisabled)? (path? path: pathname):currentPath}>
                                    <div className={"component-sidebar-menuItemIcon d-flex " +
                                                    (iconClassName? iconClassName + " ":"") + 
                                                    (menuItemIconClassName? menuItemIconClassName + " ":"") +
                                                    (isIconHidden? "invisible ":"") +
                                                    ((!isItemSelected && (!isSubmenuItemSelected)) || isDisabled? "component-sidebar-menuItemIcon_opacity ":"")}>
                                        {itemIconDisplay}
                                    </div>
                                </Link>
                            )}

                            title={(
                                <Link className="component-sidebar-menuItemWrapper d-flex align-items-center " onClick={() => path === pathname? window.location.reload():""} to={(!isDisabled)? (path? path: pathname):currentPath}>
                                    {/* Label */}
                                    {(!isCollapsed)? (
                                        <div className={"component-sidebar-menuItemLabel " + 
                                                        (menuItemLabelClassName? menuItemLabelClassName + " ":"") +
                                                        (isSubmenuItemSelected? "component-sidebar-menuItemLabel_underline ":"") +
                                                        ((!isItemSelected && (!isSubmenuItemSelected)) || isDisabled? "component-sidebar-menuItemLabel_opacity ":"")}>
                                            {/* Main Text */}
                                            <div className="component-sidebar-menuItemLabel-main">
                                                {itemLabel}
                                            </div>
            
                                            {/* Sub-Text */}
                                            <div className="component-sidebar-menuItemLabel-sub">
                                                {subItemLabel}
                                            </div>
                                        </div>
                                    ):""}
            
                                    {/* Item Selected Indicator */}
                                    {isSubmenuItemSelected && (!isCollapsed) && (!isSubmenu) && (!isSuperSubMenu)? 
                                        (<div className={"component-sidebar-menuItemIndicator"}/>)
                                    :""}
                                    
                                </Link>
                            )}
                        >
                            {/* Submenu */}
                            {(submenu != "")? (
                                <div className={"component-sidebar-submenu"}>{submenu}</div>
                            ):""}
                        </SubMenu>
                    ):(
                        <MenuItem
                            // Props specifically for library
                            firstchild={props.firstchild}
                            popperarrow={props.popperarrow}
                            onClick={() => {
                                setIsSubMenuVisible(false);
                            }}

                            className={"component-sidebar-menuItem " + 
                                (isDisabled? "component-sidebar-menuItem_noCursor ":"")}

                            icon={(
                                <Link className="component-sidebar-menuItemWrapper d-flex align-items-center " onClick={() => path === pathname? window.location.reload():""} to={(!isDisabled)? (path? path: pathname):currentPath}>
                                    <div className={"component-sidebar-menuItemIcon d-flex " +
                                                    (iconClassName? iconClassName + " ":"") + 
                                                    (menuItemIconClassName? menuItemIconClassName + " ":"") +
                                                    (isIconHidden? "invisible ":"") +
                                                    ((!isItemSelected) || isDisabled? "component-sidebar-menuItemIcon_opacity ":"")}>
                                        {itemIconDisplay}
                                    </div>
                                </Link>
                            )}
                        >
                            <div className={"component-sidebar-menuItemWrapper d-flex justify-content-between align-items-center " +
                                    (isSuperSubMenu? "component-sidebar-menuItemWrapper_super-sub-menu ":"")}>
                                <Link className="component-sidebar-menuItemLink d-flex align-items-center " onClick={() => path === pathname? window.location.reload():""} to={(!isDisabled)? (path? path: pathname):currentPath}>
                                    {/* Label */}
                                    {(!isCollapsed) || (isSubmenu)? (
                                            <div className={"component-sidebar-menuItemLabel " + 
                                                            (menuItemLabelClassName? menuItemLabelClassName + " ":"") +
                                                            (isSubmenuItemSelected? "component-sidebar-menuItemLabel_underline ":"") +
                                                            ((!isItemSelected) || isDisabled? "component-sidebar-menuItemLabel_opacity ":"")}>
                                                {/* Main Text */}
                                                <div className="component-sidebar-menuItemLabel-main">
                                                    {isSuperSubMenu? "- ":""}{itemLabel}
                                                </div>
                
                                                {/* Sub-Text */}
                                                <div className="component-sidebar-menuItemLabel-sub">
                                                    {subItemLabel}
                                                </div>
                                            </div>
                                        ):""}
            
                                    {/* Item Selected Indicator */}
                                    {isItemSelected && (!isCollapsed) && (!isSubmenu)? 
                                        (<div className={"component-sidebar-menuItemIndicator"}/>)
                                    :""}
                                    
                                </Link>

                                {isNotificationVisible? (
                                    <div className={"component-sidebar-menuItemNotification"}>{notificationValue}</div>
                                ):""}
                            </div>
                        </MenuItem>
                    )}
                    
                </React.Fragment>
            );
        });
    }

    return menu;
}